module.exports = __webpack_public_path__ + "media/services-1.fee53c3d.mp4";